// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2K38m","options":"AnswerScale_options__2hnge","selected":"AnswerScale_selected__ifsyN"};